import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
Chart.defaults.global.plugins.datalabels.display = false

export default {
  extends: Line,
  props: {
    chartData: {
      type: Object,
      default: null
    },
  },
  mixins: [reactiveProp],
  data() {
    return {
        options: {
          layout: {
            padding: {
                left: 0,
                right: 10,
                top: 10,
                bottom: 0
            }
        },
          responsive: true,
          legend: {
            display: false
         },
          scales: {
            //scaleShowLabels: false,
            yAxes: [
               {
                gridLines: {
                  display:false,
                  drawBorder: false,
              },
                ticks: {
                  
                  //max: 100,
                  beginAtZero: true,
                  stepSize: 10,
                  stepValue: 10,
                  suggestedMin: 0,
                  display: false
                }
              }
            ],
            xAxes: [
              {
                gridLines: {
                  display: false
                },
                ticks: {
                  
                  //max: 100,
                  beginAtZero: true,
                  stepSize: 10,
                  stepValue: 10,
                  suggestedMin: 0,
                 // display: false
                }
              }
            ]
          }
        }
    }
  },
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  }
}